import { HttpService, HttpServiceResponse } from '../shared'
import { FirewallAction } from './security.constants'
import { FirewallRule, FirewallEntriesServerData } from './security.types'

export class FirewallProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/ngfw_api.php`
  }

  public get(rule: FirewallRule): Promise<HttpServiceResponse<FirewallEntriesServerData>> {
    return this.http.post(`${this.url}?action=${FirewallAction.View}`, {
      Rule: rule,
    })
  }

  public add(
    ip: string,
    mask: string,
    rule: FirewallRule,
    expire: number,
    comment: string,
  ): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}?action=${FirewallAction.Add}`, {
      IP: ip,
      Mask: mask,
      Rule: rule,
      Expire: expire,
      Comment: comment,
    })
  }

  public delete(ip: string, rule: FirewallRule): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}?action=${FirewallAction.Delete}`, {
      IP: ip,
      Rule: rule,
    })
  }
}
